import { render, staticRenderFns } from "./SepticTank.vue?vue&type=template&id=1634ca92&"
import script from "./SepticTank.vue?vue&type=script&lang=js&"
export * from "./SepticTank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports